<template>
  <div>

    <nav class="hit-navbar hit-navbar-inverse hit-navbar-small hit-hidden-xs">
        <div class="hit-container hit-html-html hit-text-center" style="font-size:inherit">

             <div id="hit-navbar-top" class="hit-navbar-collapse hit-collapse">
             <!--<ul class="hit-nav hit-navbar-nav hit-navbar-left"><li class="hit-html-li">
              <router-link class="hit-html-a" :to="{ name: 'terms', params: {lang: $store.getters.lang} }">{{ $t('message.OnlyForBuisness') }}</router-link>
             </li></ul>-->
            <ul class="hit-nav hit-navbar-nav hit-navbar-right">
              <li class="hit-html-li ">
                <router-link class="hit-html-a" :to="{ name: 'contact', params: {lang: $store.getters.lang} }"><i class="hit-glyphicon hit-glyphicon-info-sign"></i> {{ $t('message.contact') }}</router-link>
              </li>
              <li class="hit-html-li"><changeLanguage class="hit-html-a" /></li>

            </ul>
            </div>

        </div>
    </nav>

    <nav v-if="!$route.params.username" class="hit-navbar hit-navbar-expand-lg hit-navbar-light hit-navbar-default">
        <div class="hit-container hit-html-html hit-text-center" style="font-size:inherit">
          <div class="hit-navbar-header hit-html-html">
            <button type="button" class="hit-navbar-toggle hit-collapsed" v-on:click="function(){ nav = !nav; }" data-toggle="collapse" data-target="#hit-navbar" aria-expanded="false" aria-controls="navbar">
              <span class="hit-sr-only">{{ $t("message.menu") }}</span>
              <hit_icon :id='"menu-hamburger"' /> {{ $t("message.menu") }}
            </button>

          <router-link class="hit-navbar-brand" :to="{ name: 'home', params: {lang: $store.getters.lang} }"><logo :id="1" /></router-link>

          </div>
          <div id="hit_navbar" class="hit-navbar-collapse hit-collapse hit-html-html" v-on:click="function(){ nav = !nav; }" v-bind:class="[{'in': nav}]">

            <ul class="hit-nav hit-navbar-nav hit-navbar-right" v-if="!$store.getters.user">

              <li class="hit-html-li "><router-link  class="hit-html-a" :to="{ name: 'sign_in', params: {lang: $store.getters.lang} }">{{ $t('message.signIn') }}</router-link></li>
              <li class="hit-html-li "><router-link class="hit-html-a" :to="{ name: 'sign_up', params: {lang: $store.getters.lang} }">{{ $t('message.signUp') }}</router-link></li>

            </ul>

            <ul class="hit-nav hit-navbar-nav hit-navbar-right" v-else>

              <li class="hit-html-li hit-active"><router-link  class="hit-html-a" :to="{ name: 'app', params: {lang: $store.getters.lang} }">{{ $t('message.dashboard') }}</router-link></li>
              <li class="hit-html-li"><router-link  class="hit-html-a" :to="{ name: 'sign_in', params: {lang: $store.getters.lang} }">{{ $t('message.logout') }}</router-link></li>

            </ul>

            <ul class="hit-nav hit-navbar-nav">

              <li class="hit-html-li"><router-link class="hit-html-a" :to="{ name: 'home', params: {lang: $store.getters.lang} }">{{ $t('message.home') }}</router-link></li>

            </ul>

        </div>
      </div>

    </nav>
  </div>

</template>

<script>

import logo from '@core/components/assets/logo.vue'
import changeLanguage from '@core/components/assets/hit_change_language.vue'

export default {
  components: {logo, changeLanguage},
  data: function () {
    return {
      nav: false
    }
  }

}

</script>
